import Image from 'next/image'

interface QRCodeGeneratorProps {
  url: string
}

export default function QRCodeGeneratorModal({ url }: QRCodeGeneratorProps) {
  if (!url) {
    return null
  }

  return (
    <>
      <div
        className="flex-col p-1.25 flex justify-center items-center"
        style={{
          // backgroundImage: 'url(/svgs/green-border.svg)',
          // backgroundSize: 'cover',
        }}
      >
        <div
          className="flex justify-center items-center rounded w-full h-full "
  
        >
         

<div 
            className="flex justify-center items-center aspect-square"
            style={{
              width: '121px',
              height: '121px',
              padding: '1px 1.448px 1.448px 1px',
            }}
          >
            <Image
              src="/images/QR.png"
              alt="QR Code"
              width={121}
              height={121}
              className="w-full h-full object-contain"
            />
          </div>

         
          {/* <p className="mt-2 text-sm text-gray-600 break-all">{url}</p> */}
        </div>
      </div>
    </>
  )
}
